<template>
  <div class="all-height all-width pt-6 px-6 " data-testid="analysis-base">
    <div class="" :class="{ 'loading-state': loading || isReportingUnitdataloading }">
      <div class="">
          <div class="filter-toolbar-container d-flex align-center gap-3 flex-wrap justify-space-between mb-6">
            <!-- Back button container - fixed width to prevent layout shift -->
            <div class="back-btn-container gap-2 align-center">
              <v-btn v-if="selectedreportingunit && selectedreportingunit !== 'all'"
                @click=' isReportingUnitClicked = false, setRportingUnitFilter()' class="pa-1" small>
                <v-icon>mdi mdi-arrow-left-bold</v-icon>
              </v-btn>
              <!-- <v-btn
                v-else-if="showBackButton"
                @click='backFilterStatus()' class="pa-1" small>
                <v-icon>mdi mdi-arrow-left-bold</v-icon>
              </v-btn> -->
              <h4 class="font-weight-medium">{{ cycletype === 'Forecast' ? $nova.labelsName('cycle_page', 'forecast_cycle_label', 'Forecast Cycle') : $nova.labelsName('cycle_page', 'variance_analysis_label', 'Actual Cycle') }}</h4>
            </div>
            <!-- Filter container - centered and flexible -->
            <div class="filter-wrapper">
              <cfilter ref="childfilter"
                :cycletype="cycletype"
                @newdata="listenfilter"
                @isDataSynced="manualFiltersync"
                @isReportingunitSelected="setReportingUnit"
                :is-loading="loading"
                @manual-filter-refresh="manualFilterRefresh"
              />
            </div>
            <!-- Sync button container - fixed width to prevent layout shift -->
            <div class="sync-btn-container">
              <!-- <v-btn @click="manualFilterRefresh()" class="secondaryBtn">
                <v-icon :class="{ 'rotate': isFiltersDataLoading }" class="icon">mdi-sync</v-icon>
                <span class="">{{ $nova.labelsName('cycle_page', 'commentary_sync_now_label', 'Sync now')  }}</span>
              </v-btn> -->
            </div>
          </div>
          <r-u-view-toolbar
            :toggleview="toggleview"
            :selectedreportingunit="selectedreportingunit"
            :selectedperiod="selectedperiod"
            :selectedregionalapproval="selectedregionalapproval"
            :selectedlocalapproval="selectedlocalapproval"
            :isregionalapproverinru="isregionalapproverinru"
            :islocalapproverinru="islocalapproverinru"
            :reporting-units-for-mail-reminder="reportingUnitsForMailReminder"
            :selectednetwork="selectednetwork"
            :last-updated-at="lastUpdatedAt"
            :commentary-regional-key-label="commentary_regional_key_label"
            @navigate-view="navigateView"
            @approve-regional-ru="approveRegionalRU"
            @approve-local-ru="approveLocalRU"
            @show-email-reminder="showEmailReminderConfirm"
            @sync-now="loadContent(false, true, 'manual')"
            @download-all-ru-cycle="getDownloadAllRUcyclelist"
            @download-all-ru="getDownloadAllRUlist"
            @refresh-data="loadContent(true)"
          />
          <div class="pa-5 title grey--text text-center" v-if="role.length === 0">
            <span class="dots-loader">Please wait as we load your data<span>.</span><span>.</span><span>.</span></span>
            <div>If you are unable to see your data on this screen then kindly contact admin to provide you with access
            </div>
          </div>
          <div v-else>
            <div v-if="selectedyear === 'all'">
              <div class="title grey--text">{{ 'Select a Year'  }}</div>
              <div class="">
                <template v-for="(v, k) in year">
                  <div :key="k" @click="selectedyear = v._id" v-if="v._id !== 'all'"
                    class="d-inline-block px-4 py-2 hoverable border-left-grey border-on cursor-pointer mr-4 mt-2">
                    {{ v._id }}
                  </div>
                </template>
              </div>
            </div>
            <div v-else-if="selectedperiod === 'all'">
              <span v-if="perioddata.length > 0">Note: GL status wise summary is available if period is selected.</span>
              <!-- <RUList type="Period" :data="perioddata" @click="setPeriod" @getreportingunit="loadReportingUnit" :view="toggleview"></RUList> -->
              <RUList type="Period" :data="perioddata" @click="setPeriod" @getreportingunit="loadReportingUnit(false, false)"
                :view="toggleview" :loading='loading'></RUList>

            </div>
            <div v-else-if="toggleview === 0 && !isReportingUnitClicked && selectedperiod !== 'all'">
              <RUList ref="ruList" type="Reporting Unit" :data="reportingunitdata" @click="setReportingUnit"
                :view="toggleview" :enablecheckboxlocal="islocalapproverinru"
                :enablecheckboxregional="isregionalapproverinru" :enableMailSenderCheckbox="isMailRemainderRequired"
                :isfiltereddata="isFilteredData" @approvelocal="setapprovelocalids" :isDataRefreshed="isDataRefreshed"
                @approveregional="setapproveregionalids" @multipleReminderMails="setReportingUnitsForMailReminder"
                @sendRemainderMail="sendEmailReminderForSelectedCycle" :loading="loading"
                :has-more="hasMoreReportingUnits"
                @getreportingunit="handleReportingUnitRequest" :cycletype="cycletype">
              </RUList>
            </div>
            <div v-else-if="selectednetwork === 'all' && (toggleview === 2 || toggleview === 1)">
              <RUList type="Network" :data="networkdata" @click="setNetwork" :view="toggleview"
                :isfiltereddata=isFilteredData @getnetworkdata="loadNetwork" :loading="loading">
              </RUList>
            </div>
            <div v-else-if="selectedregion === 'all' && toggleview !== 3 && toggleview !== 0">
              <RUList type="Region" :data="regiondata" @click="setRegion" :view="toggleview" :loading="loading">
              </RUList>
            </div>
            <div v-else-if="selectedcountry === 'all' && toggleview !== 3 && toggleview !== 0">
              <RUList type="Country" :data="countrydata" @click="setCountry" :view="toggleview" :loading="loading">
              </RUList>
            </div>
            <div
              v-else-if="selectedperiod !== 'all' && selectedperiod && (selectedreportingunit === 'all') && toggleview !== 3">
              <RUList type="Reporting Unit" :data="reportingunitdata" @click="setReportingUnit" :view="toggleview"
                :enablecheckboxlocal="islocalapproverinru" :enablecheckboxregional="isregionalapproverinru"
                :isDataRefreshed="isDataRefreshed" :isfiltereddata="isFilteredData" @approvelocal="setapprovelocalids"
                @approveregional="setapproveregionalids" @getreportingunit="handleReportingUnitRequest" :loading="loading"
                :has-more="hasMoreReportingUnits">
              </RUList>
            </div>
            <div v-else-if="(selectedreportingunit !== 'all' && selectedreportingunit) || (toggleview === 0 && isReportingUnitClicked) || toggleview === 3">
              <r-u-data-section
              :selectedreportingunit="selectedreportingunit"
              :isReportingUnitClicked="isReportingUnitClicked"
              :isReportingUnitdataloading="isReportingUnitdataloading"
              :commentarydata="commentarydata"
              :filteredcommentarydata="filteredcommentarydata"
              :pagedItems="pagedItems"
              :commentarycycledata="commentarycycledata"
              :commentarycycledatalist="commentarycycledatalist"
              :commentarysummarydata="commentarysummarydata"
              :toggleview="toggleview"
              :toggletableview="toggletableview"
              :isCommentaryView="isCommentaryView"
              :customfilterstoggle="customfilterstoggle"
              :selectedfilter="selectedfilter"
              :multiselectdata="multiselectdata"
              :workflows="workflows"
              :ispreparer="ispreparer"
              :isapprover="isapprover"
              :isregionalapprover="isregionalapprover"
              :ismanager="ismanager"
              :isviewonly="isviewonly"
              :ispendinglocalruapproval="ispendinglocalruapproval"
              :ispendingregionalruapproval="ispendingregionalruapproval"
              :isSodEnabled="isSodEnabled"
              :ruRoleOptions="ruRoleOptions"
              :selectedRuRole="selectedRuRole"
              :alluserassigned="alluserassigned"
              :commentary_local_key_label="commentary_local_key_label"
              :commentary_regional_key_label="commentary_regional_key_label"
              :local_controls_label="local_controls_label"
              :local_management_label="local_management_label"
              :regional_controls_label="regional_controls_label"
              :regional_management_label="regional_management_label"
              :actual_label="actual_label"
              :proforma_shortform_label="proforma_shortform_label"
              :forcast_shortform_label="forcast_shortform_label"
              :workflowsDisabledMessage="workflowsDisabledMessage"
              :cycletype="cycletype"
              :cycletypeReadview="cycletypeReadview"
              :cycletypeItem="cycletypeItem"
              :tablecolors="tablecolors"
              :expandedIds="expandedIds"
              :isAllExpanded="isAllExpanded"
              :page="page"
              :pagecount="pagecount"
              :pageSize="pageSize"
              :workflowtext="workflowtext"
              :activitylogconfigcycle="activitylogconfigcycle"
              :activitylogconfiggl="activitylogconfiggl"
              :clientbyclientdata_netsales="clientbyclientdata_netsales"
              :clientbyclientdata_revenue="clientbyclientdata_revenue"
              :cyclestage="cyclestage"
              :isFilterSet="isFilterSet"
              :periodName="periodlist[selectedperiod] ? periodlist[selectedperiod].name : ''"
              :yearName="String(selectedyear || '')"
              @update:selected-filter="selectedfilter = $event"
              @update:custom-filters-toggle="customfilterstoggle = $event"
              @toggle-view="toggleViewFun"
              @select-all="select_all"
              @toggle-expand="toggleExpand"
              @toggle-expand-all="toggleExpandAll"
              @row-intersect="handleIntersect"
              @get-net-sales-data="getNetSalesData" 
              @get-revenue-data="getRevenueData"
              @open-user-list-dialog="userlistdialog = true"
              @open-custom-filters-dialog="customfiltersdialog = true"
              @open-submit-dialog="({ row, mode, approver }) => openSubmitDialog(row, mode, approver)"
              @perform-bulk-task="performBulkTask"
              @preview-bulk-commentary="previewBulkCommentary"
              @open-bulk-commentary-dialog-local="bulkcommentaryDialogueOpen"
              @open-bulk-commentary-dialog-approver="bulkcommentaryDialogueOpenisApprover"
              @open-bulk-approve-dialog="bulkapproveDialogueOpen"
              @get-previous-cycle-list="getPreviousCycleList"
              @download-excel="downloadExcel"
              @download-pdf="getpdfFun"
              @refresh-ru-data="loadData"
              @download-all-ru-cycle-list="getDownloadAllRUcyclelist"
              @download-all-ru-list="getDownloadAllRUlist"
              @update:selectedRuRole="val => (selectedRuRole = val)"
              @update:page="val => (page = val)"
              @update:multiselectdata="val => (multiselectdata = val)"
              @open-workflows-dialog="workflowsdialog = true"
            />
          </div>
          </div>
      </div>

      <email-reminder-dialog v-model="confirmEmailReminderDialog" :loading="emailreminderdialogloading"
         @confirm="confirmSendEmailReminder" @cancel="cancelEmailReminder">
      </email-reminder-dialog>

      <status-help-dialog v-model="statushelpdialog" />

      <lb-dialog v-model="bulksubmitdialog" heading="Bulk Upload Commentary"
        :width="(Object.keys(bulksubmitfiledata).length > 0) ? '' : '500'" :loading="bulksubmitloading">
        <template v-slot:body>
          <div class="mb-2 d-flex align-center justify-center">
            <v-btn color="primary" class="mr-2" @click="downloadExcel()"><span>Download Template</span></v-btn>
            <lb-file v-model="bulksubmitfiledatafile" label="" :drag="false" hidedetails @change="readBulkSubmit()"
              :displayname="false" accept=".xlsx,.xls,.xlsm,.xlsb" />
          </div>
          <div v-if="Object.keys(bulksubmitfiledata).length > 0">
            <div v-if="bulksubmitfiledataerror" class="error--text font-weight-semibold">
              We found few errors. Please rectify the same to proceed with the upload
            </div>
            <lb-datatablenew :headers="bulkUploadCommentaryHeaders" :items="bulksubmitfiledataList"
              :enableslot="['message', 'ignore']" :loading="bulksubmitloading">
              <template v-slot:ignore="{ item }">
                <td style="width:30px;">
                  <v-icon v-if="(item.error || !item.__found)" color="error">mdi-close-circle</v-icon>
                  <v-icon v-else-if="!item.ignore" color="success">mdi-check-circle</v-icon>
                </td>
              </template>
              <template v-slot:message="{item}">
                <td :class="`${(bulksubmitfiledataerror || item.ignore)?'error--text':''}`">
                  <span v-if="!item.__found">{{$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code')}} not found</span>
                  <span v-else>{{item.error || item.message}}</span>
                </td>
              </template>
            </lb-datatablenew>
          </div>
          <div v-else class="grey--text pa-6 text-center title">
            Upload template file
          </div>
        </template>
        <template v-slot:actions>
          <div v-if="bulksubmitfiledataerror" class="error--text font-weight-semibold">
            We found few errors. Please rectify the same to proceed with the upload
          </div>
          <div v-else-if="Object.keys(bulksubmitfiledata).length > 0" class="">
            Note: Only the GL's which are in {{
              $nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaited','Local commentary awaited') }}
            will be updated with this bulk upload option.
          </div>
          <v-spacer></v-spacer>
          <v-btn v-if="Object.keys(bulksubmitfiledata).length > 0 && !bulksubmitfiledataerror"
            @click="bulkUploadCommentaryByGL()" color="" class="ml-2 secondaryBtn"
            :disabled='(ispreparer && !workflows.lcp && !workflows.lmp && !workflows.lcf && !workflows.lmf)'><span>Proceed to
            Upload</span></v-btn>
        </template>
      </lb-dialog>

      <bulk-upload-commentary-approver-dialog
        v-model="approverBulkSubmitPop"
        :loading="approverBulkSubmitLoading"
        :width="Object.keys(approverBulkSubmitData).length > 0 ? '' : '500'"
        :file-value="approverBulkSubmitDataFile"
        :headers="bulkUploadCommentaryisApproverHeaders"
        :items="approverBulkSubmitFileDataListis"
        :has-error="bulksubmitfiledataerrorisApprover"
        :disable-submit="isBulkSubmitDisabled"
        :gl-code-label="$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code')"
        :local-commentary-awaited-label="$nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaited','Local commentary awaited')"
        @download-template="downloadExcelisApprover"
        @file-change="readBulkSubmitisApprover"
        @update:file-value="val => (approverBulkSubmitDataFile = val)"
        @submit="bulkUploadCommentaryByGLisApprover"
      />

      <bulk-approve-local-dialog
        v-model="bulkapprovelocaldialog"
        :loading="bulkapprovelocalloading"
        :width="Object.keys(bulkapprovelocalfiledata).length > 0 ? '' : '500'"
        :file-data-list="bulkApproveLocalItems"
        :has-error="bulkapprovelocalfiledataerror"
        :is-regional-commentary-automation-enabled="isRegionalCommentaryAutomationEnabled"
        :is-approver="isapprover"
        :file-value="bulkapprovelocalfiledatafile"
        @download-template="downloadExcel"
        @file-change="readBulkApproveLocal"
        @update:file-value="val => (bulkapprovelocalfiledatafile = val)"
        @upload="bulkUploadApproveLocalCommentaryByGL"
      />
      <commentary-dialog
      v-model="commantorydialog"
      :loading="commentaryloading"
      :bulksubmit="bulksubmit"
      :bulktype="bulktype"
      :bulkcommentall.sync="bulkcommentall"
      :bulkcommentreplace.sync="bulkcommentreplace"
      :selectedcommentary="selectedcommentary"
      :multiselectdata="multiselectdata"
      :tablecolors="tablecolors"
      :cycletype="cycletype"
      :cycletypeReadview="cycletypeReadview"
      :ispreparer="ispreparer"
      :isapprover="isapprover"
      :isregionalapprover="isregionalapprover"
      :userid="userid"
      :sodEnabled="isSodEnabled"
      :workflowtext="workflowtext"
      :workflows="workflows"
      :cyclestage="cyclestage"
      :commentary_local_key_label="commentary_local_key_label"
      :commentary_regional_key_label="commentary_regional_key_label"
      :aggregatedLabelText="aggregatedLabelText"
      :localCommentaryGenAiBtntab="localCommentaryGenAiBtntab"
      :isRegionalCommentaryAutomationEnabled="isRegionalCommentaryAutomationEnabled"
      :isLocalCommentaryCollapsed="isLocalCommentaryCollapsed"
      :isLocalCommentaryReasonCollapsed="isLocalCommentaryReasonCollapsed"
      :isGlMandatoryRequestFlag="isGlMandatoryRequestFlag"
      :replaceExistingCommentFlag="replaceExistingCommentFlag"
      :charttab.sync="charttab"
      :commentarySubmitDialogueViewMode="commentarySubmitDialogueViewMode"
      :toggleview="toggleview"
      :lastActionsOnGL="lastActionsOnGL"
      :attachmentfile.sync="attachmentfile"
      :attachmentfileloading="attachmentfileloading"
      :attachmentfilepercentage="attachmentfilepercentage"
      :isTyping="isTyping"
      :loadingtext1="loadingtext1"
      :loadingtext2="loadingtext2"
      :isThresholdExceedLocalCommentary="isThresholdExceedLocalCommentary"
      :isThresholdExceedJVSummarisation="isThresholdExceedJVSummarisation"
      :showSummaryTab="showSummaryTab"
      :summaryAiProforma.sync="summaryAiProforma"
      :summaryAiForecast.sync="summaryAiForecast"
      :aitext.sync="aitext"
      :requestcommentarylocalcontrol.sync="requestcommentarylocalcontrol"
      :requestcommentarylocalmanagement.sync="requestcommentarylocalmanagement"
      :requestcommentaryregionalcontrol.sync="requestcommentaryregionalcontrol"
      :requestcommentaryregionalmanagement.sync="requestcommentaryregionalmanagement"
      :requestcommentarylocalcontrolvsProforma.sync="requestcommentarylocalcontrolvsProforma"
      :requestcommentarylocalcontrolvsForecast.sync="requestcommentarylocalcontrolvsForecast"
      :requestcommentarylocalmanagementvsProforma.sync="requestcommentarylocalmanagementvsProforma"
      :requestcommentarylocalmanagementvsForecast.sync="requestcommentarylocalmanagementvsForecast"
      @toggle-local-commentary-collapse="toggleLocalCommentaryCollapse"
      @toggle-local-commentary-reason-collapse="toggleLocalCommentaryReasonCollapse"
      @generate-ai="({ commentary, slot, mode }) => generateAI(commentary, slot, mode)"
      @generate-ai-summary="({ commentary, slot, mode }) => generateAIsummery(commentary, slot, mode)"
      @attachment-change="uploadAttachmentFile"
      @approve-commentary="approveCommentary"
      @reject-commentary="rejectCommentary"
      @save-commentary="saveCommentary"
      @add-commentary="addCommentary"
    />

      <request-commentary-dialog
        v-model="requestcommentarydialog"
        :heading="bulksubmit ? 'Bulk Request Commentary' : 'Request Commentary'"
        :width="800"
        :loading="requestcommentaryloading"
        :bulksubmit="bulksubmit"
        :multiselectcount="multiselectdata.length"
        :selectedcommentary="selectedcommentary"
        :isapprover="isapprover"
        :isregionalapprover="isregionalapprover"
        :workflowtext="workflowtext"
        :workflows="workflows"
        :local-controls-label="local_controls_label"
        :local-management-label="local_management_label"
        :regional-controls-label="regional_controls_label"
        :regional-management-label="regional_management_label"
        :proforma-label="proforma_shortform_label"
        :forecast-label="forcast_shortform_label"
        :requestcommentarylocalcontrolvsProforma="requestcommentarylocalcontrolvsProforma"
        :requestcommentarylocalmanagementvsProforma="requestcommentarylocalmanagementvsProforma"
        :requestcommentarylocalcontrolvsForecast="requestcommentarylocalcontrolvsForecast"
        :requestcommentarylocalmanagementvsForecast="requestcommentarylocalmanagementvsForecast"
        :requestcommentaryregionalcontrolvsProforma="requestcommentaryregionalcontrolvsProforma"
        :requestcommentaryregionalmanagementvsProforma="requestcommentaryregionalmanagementvsProforma"
        :requestcommentaryregionalcontrolvsForecast="requestcommentaryregionalcontrolvsForecast"
        :requestcommentaryregionalmanagementvsForecast="requestcommentaryregionalmanagementvsForecast"
        @request="requestCommentary"
        @update:requestcommentarylocalcontrolvsProforma="val => (requestcommentarylocalcontrolvsProforma = val)"
        @update:requestcommentarylocalmanagementvsProforma="val => (requestcommentarylocalmanagementvsProforma = val)"
        @update:requestcommentarylocalcontrolvsForecast="val => (requestcommentarylocalcontrolvsForecast = val)"
        @update:requestcommentarylocalmanagementvsForecast="val => (requestcommentarylocalmanagementvsForecast = val)"
        @update:requestcommentaryregionalcontrolvsProforma="val => (requestcommentaryregionalcontrolvsProforma = val)"
        @update:requestcommentaryregionalmanagementvsProforma="val => (requestcommentaryregionalmanagementvsProforma = val)"
        @update:requestcommentaryregionalcontrolvsForecast="val => (requestcommentaryregionalcontrolvsForecast = val)"
        @update:requestcommentaryregionalmanagementvsForecast="val => (requestcommentaryregionalmanagementvsForecast = val)"
      />

      <previous-cycle-list-dialog
        v-model="previouscyclelistdialog"
        :loading="previouscyclelistloading"
        :previouscyclelist="previouscyclelist"
        :commentary-label="commentary_local_key_label"
        @select="getPreviousCycleData"
      />

      <previous-cycle-data-dialog
        v-model="previouscycledatadialog"
        :loading="previouscycledataloading"
        :previouscycledatatoupload="previouscycledatatoupload"
        :prevselected="prevcommentaryselect"
        :tablecolors="tablecolors"
        :cycletype="cycletype"
        :proforma-label="proforma_shortform_label"
        :forecast-label="forcast_shortform_label"
        :gl-code-label="$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code')"
        @update:selected-list="val => (prevcommentaryselect = val)"
        @upload="uploadPreviousCycleCommentary"
      />

      <user-list-dialog
      v-model="userlistdialog"
      :commentary-ru-data="commentaryrudata"
      :userid="userid"
      :multi-role-users="multiRoleUsers"
      :local-preparer-label="$nova.labelsName('cycle_page', 'commentary_local_preparer_label', 'Local Preparer')"
      :local-approver-label="$nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver')"
      :regional-approver-label="$nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approver')"
    />

     

      <net-sales-breakup-dialog
        v-model="clientbyclientdialog_netsales"
        :loading="clientbyclientloading_netsales"
        :width="max_netsales_revenue_dialog_width"
        :breakdown-data="breakdownData"
        :net-sales-view-mode="netSalesViewMode"
        :expanded-groups="expandedGroups"
        :clientbyclient-data="filteredClientbyClientDataNetSales"
        :clientbyclient-full-data="clientbyclientdata_netsales"
        :client-type-headers="clientTypeHeaders"
        :client-by-client-headers="clientbyclient_headers"
        :is-preparer="ispreparer"
        :is-pending-local="ispendinglocalruapproval"
        :is-pending-regional="ispendingregionalruapproval"
        :is-special-ru="isSpecialRu"
        @open-upload-commentary="handleOpenNetSalesUpload"
        @toggle-revenue-group="toggleRevenueGroup"
        @update:net-sales-view-mode="val => (netSalesViewMode = val)"
      />
      <upload-net-sales-commentary-dialog
        v-model="uploadnetsalescommentarydialog"
        :loading="uploadnetsalescommentaryloading"
        :width="1500"
        :headers="[...clientbyclient_headers, { text: 'Message', value: 'message', lock: true }]"
        :items="uploadfiledata_netsales"
        :enableslot="['actual_amount', 'forecast_amount', 'proforma_amount', 'actual_vs_proforma_variance_amount', 'actual_vs_forecast_variance_amount', 'commentary1', 'commentary2', 'message']"
        :show-submit="!uploadclientbyclienterror && uploadfiledata_netsales.length > 0"
        :file-value="uploadclientbyblientfile"
        @file-change="processClientbyclientUploadFile('netsales')"
        @update:file-value="val => (uploadclientbyblientfile = val)"
        @download-template="downloadRevenueCommentaryTemplate('netsales')"
        @submit="uploadclientbyclientCommentary('netsales')"
      />

        <revenue-breakup-dialog
        v-model="clientbyclientdialog_revenue"
        :loading="clientbyclientloading_revenue"
        :width="max_netsales_revenue_dialog_width"
        :breakdown-data="breakdownData"
        :revenue-view-mode="revenueViewMode"
        :expanded-groups="expandedGroups"
        :clientbyclient-data="filteredClientbyClientDataRevenueBreakup"
        :clientbyclient-full-data="clientbyclientdata_revenue"
        :client-type-headers="DEMOAPPENABLED ? clientTypeHeadersDemoApp : clientTypeHeaders"
        :client-by-client-headers="clientbyclient_headers"
        :is-preparer="ispreparer"
        :is-pending-local="ispendinglocalruapproval"
        :is-pending-regional="ispendingregionalruapproval"
        :is-special-ru="isSpecialRu"
        :tablecolors="tablecolors"
        :selected-commentary="selectedcommentary"
        :revenue-ai-proforma="revenueAIProforma"
        :revenue-ai-forecast="revenueAIForecast"
        :revenue-ai-loading-proforma="revenueAILoadingProforma"
        :revenue-ai-loading-forecast="revenueAILoadingForecast"
        :is-typing="isTyping"
        :is-threshold-exceed-revenue-commentary="isThresholdExceedRevenueCommentary"
        :revenue-commentary-gen-ai-btntab="revenueCommentaryGenAiBtntab"
        :actual-label="actual_label"
        :proforma-label="proforma_shortform_label"
        :forecast-label="forcast_shortform_label"
        @open-upload-commentary="handleOpenRevenueUpload"
        @toggle-revenue-group="toggleRevenueGroup"
        @update:revenue-view-mode="val => (revenueViewMode = val)"
        @generate-ai="payload => generateAIRevenue(payload.commentary || selectedcommentary, payload.mode, payload.forecastType)"
        @update:revenue-ai-proforma="val => (revenueAIProforma = val)"
        @update:revenue-ai-forecast="val => (revenueAIForecast = val)"
      />

      <upload-revenue-commentary-dialog
        v-model="uploadrevenuecommentarydialog"
        :loading="uploadrevenuecommentaryloading"
        :upload-data="uploadfiledata_revenue"
        :headers="clientbyclient_headers"
        :has-error="uploadclientbyclienterror"
        @file-change="processClientbyclientUploadFile('revenue')"
        @download-template="downloadRevenueCommentaryTemplate('revenue')"
        @submit="uploadclientbyclientCommentary('revenue')"
      />
      
      <WarningDialog
        v-model="showErrorMessageDialog"
        :message="errorMessageDialogContent"
        title="Important Notice"
        icon="mdi-alert"
        icon-color="error"
        button-text="Close"
        button-color="error"
        :width="800"
        @close="handleDialogClose"
      />
      <activity-log-dialog
        v-model="activitylogdialog"
        :loading="activitylogloading"
        :activitylogdata="activitylogdata"
      />

      <custom-filters-dialog
        v-model="customfiltersdialog"
        :searchcustom="searchcustom"
        :customfilter="customfilter"
        :filteredcommentarydata="filteredcommentarydata"
        @update:searchcustom="val => (searchcustom = val)"
        @update:customfilter="val => (customfilter = val)"
        @save="saveCustomFilter"
      />
      <r-u-approval-dialog
        v-model="ruapprovaldialog"
        :loading="ruapprovalloading"
        :heading="$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU') + ' level approval'"
        :approval-type="ruapprovaltype"
        :note="rulevelapprovenote"
        @update:note="val => (rulevelapprovenote = val)"
        @proceed="approveRU"
      />

      <all-units-data-download-dialog
        v-model="allrudownloaddialog"
        :loading="allrudownloadloading"
        :years-list="yearsList"
        :download-period-list="downloadperiodlist"
        :current-year="allRUDownloadYear"
        :current-period="allRUDownloadPeriod"
        :downloads="allrudownloadlist"
        @update:year="val => (allRUDownloadYear = val)"
        @update:period="val => (allRUDownloadPeriod = val)"
        @generate="downloadAllRU"
        @download="downloadAllRU"
      />

      <r-u-cycle-download-dialog
        v-model="allrucycledownloaddialog"
        :loading="allrucycledownloadloading"
        :heading="$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU') + ' Cycle Approval Reports'"
        :years-list="yearsList"
        :download-period-list="downloadperiodlist"
        :current-year="allRUDownloadYear"
        :current-period="allRUDownloadPeriod"
        :downloads="allrucycledownloadlist"
        @update:all-ru-download-year="val => (allRUDownloadYear = val)"
        @update:all-ru-download-period="val => (allRUDownloadPeriod = val)"
        @generate="downloadAllRUcycle"
        @download="downloadAllRUcycle"
      />

      <lb-dialog v-model="workflowsdialog" :loading="allrucycledownloadloading" heading="Workflows status" width="600">
        <template v-slot:body>
          <WorkflowsStatus
            :allworkflowstext="allworkflowstext"
            :workflowtext="workflowtext"
            :allworkflowskeys="allworkflowskeys"
            :sodEnabled="isSodEnabled"
          />
        </template>
      </lb-dialog>

      <bulk-preview-add-commentary-dialog
      v-model="previewBulkAddCommentarydialog"
      :file-data="bulksubmitfiledata"
      :headers="bulkUploadCommentaryHeaders"
      :loading="bulksubmitloading"
      :is-preparer="ispreparer"
      :workflows="workflows"
      @submit="bulkUploadCommentaryByGL(true)"
    />

      <pdf-download-dialog
        v-model="rucyclepdfdownloaddialog"
        :loading="rucyclepdfdownloadloading"
        :items="rucyclepdfdownloadlist"
        @generate="pdfdownloadRUcycleGenerate"
        @download="downloadRUPdfFile"
      />

      <RevenueBreakupDetailedInformation
        v-model="revenueDetailDialog"
        :selectedRevenueDetail="selectedRevenueDetail"
        :proformaShortformLabel="proforma_shortform_label"
        :forecastShortformLabel="forcast_shortform_label"
        :tablecolors="tablecolors"
        @close="revenueDetailDialog = false"
      />
      
    </div>
  </div>
</template>
<script>
import cfilter from '../Filter'
import RUList from './List'
import varianceAnalysisConstants from "../../constants"
// let xlsx = require('xlsx');
import { Chart, LineController, LineElement, PointElement, Title, Tooltip, CategoryScale, LinearScale, BarController, BarElement, Legend } from 'chart.js';
Chart.register(LineController, LineElement, PointElement, Title, Tooltip, CategoryScale, LinearScale, BarController, BarElement, Legend);
import WarningDialog from '../../components/WarningDialog.vue';

import WorkflowsStatus from "../../components/WorkflowDialog.vue"
import RevenueBreakupDetailedInformation from '../../components/RevenueBreakupDetailedInformation.vue';
import RUViewToolbar from '../../components/RUViewToolbar.vue';
import RUDataSection from "../../components/RUDataSection.vue";
import NetSalesBreakupDialog from '../../modals/NetSalesBreakupDialog.vue';
import RevenueBreakupDialog from '../../modals/RevenueBreakupDialog.vue';
import EmailReminderDialog from '../../modals/EmailReminderDialog.vue';
import UserListDialog from '../../modals/UserListDialog.vue';
import PreviousCycleListDialog from '../../modals/PreviousCycleListDialog.vue';
import PreviousCycleDataDialog from '../../modals/PreviousCycleDataDialog.vue';
import RequestCommentaryDialog from '../../modals/RequestCommentaryDialog.vue';
import PdfDownloadDialog from '../../modals/PdfDownloadDialog.vue';
import BulkPreviewAddCommentaryDialog from '../../modals/BulkPreviewAddCommentaryDialog.vue'; // Add this import
import CustomFiltersDialog from '../../modals/CustomFiltersDialog.vue';
import ActivityLogDialog from '../../modals/ActivityLogDialog.vue';
import RUCycleDownloadDialog from '../../modals/RUCycleDownloadDialog.vue';
import AllUnitsDataDownloadDialog from '../../modals/AllUnitsDataDownloadDialog.vue';
import UploadNetSalesCommentaryDialog from '../../modals/UploadNetSalesCommentaryDialog.vue';
import RUApprovalDialog from '../../modals/RUApprovalDialog.vue';
import UploadRevenueCommentaryDialog from '../../modals/UploadRevenueCommentaryDialog.vue';
import StatusHelpDialog from '../../modals/StatusHelpDialog.vue';
import BulkApproveLocalDialog from '../../modals/BulkApproveLocalDialog.vue';
import BulkUploadCommentaryApproverDialog from '../../modals/BulkUploadCommentaryApproverDialog.vue';
import CommentaryDialog from '../../modals/CommentaryDialog.vue'; // ADD THIS IMPORT





import helpers from '../../utils/helpers';

export default {
  name: 'commentaryworking',
  data: function () {
    return {
      pageame: "cycle_page",
      loading: false,
      userid: '',
      toggleview: 0,
      toggletableview: 0,
      ispreparer: false,
      isapprover: false,
      ispendinglocalruapproval: false,
      ispendingregionalruapproval: false,
      isregionalapprover: false,
      ismanager: false,
      isviewonly: false,
      cyclestage: 0,
      commentarydata: [],
      commentarydatajson: {},
      commentarydatajsonById: {},
      commentarydatajsonByGLCode: {},
      commentaryrudata: {},
      commentarycycledata: {},
      commentarysummarydata: {},
      commentarylocalsummarydata: {},
      commentaryregionalsummarydata: {},
      gllist: {},
      // selectedfilter moved to computed property for Vuex persistence
      hierarchyData: {},
      selectedrole: "",
      role: [],
      rolelist: {},
      selectedyear: 2023,
      year: [],
      yearlist: {},
      yearsList: [],
      selectedperiod: "",
      period: [],
      perioddata: [],
      periodlist: {},
      selectednetwork: "all",
      network: [],
      networkdata: [],
      networklist: {},
      selectedregion: "all",
      region: [],
      regiondata: [],
      regionlist: {},
      selectedcountry: "all",
      country: [],
      countrydata: [],
      selectedreportingunit: "",
      reportingunit: [],
      reportingunitdata: [],
      reportingunitlist: {},
      statushelpdialog: false,
      commantorydialog: false,
      bulktype: "",
      bulksubmit: false,
      bulkcommentall: false,
      bulkcommentreplace: false,
      viewdialog: false,
      viewdata: {},
      selectedcommentary: {},
      revenueAIProforma:"",
      revenueAIForecast:"",
      summaryAiProforma:"",
      summaryAiForecast:"",
      revenueAILoadingProforma:false,
      revenueAILoadingForecast:false,
      revenueairesopone:false,
      fullText: "",
      revenueAIResponseText: "",
      displayedText: "",
      loadingtext1: false,
      loadingtext2: false,
      index: 0,
      speed: 0, // Typing speed in milliseconds
      isTyping: false,
      aitext: "", // Ensure aitext is defined for typeEffectRevenue
      shouldStop:false,
      commentaryloading: false,
      commentarytype: '',
      requestcommentarydialog: false,
      requestcommentaryloading: false,
      confirmEmailReminderDialog: false,
      emailreminderdialogloading: false,
      pageSize: 200,
      //workflows old flags
      requestcommentarylocalcontrol: false,
      requestcommentarylocalmanagement: false,
      requestcommentaryregionalcontrol: false,
      requestcommentaryregionalmanagement: false,
      //workflows new flags for request commentary 
      requestcommentarylocalcontrolvsProforma: false,
      requestcommentarylocalmanagementvsProforma: false,
      requestcommentaryregionalcontrolvsProforma: false,
      requestcommentaryregionalmanagementvsProforma: false,
      requestcommentarylocalcontrolvsForecast: false,
      requestcommentarylocalmanagementvsForecast: false,
      requestcommentaryregionalcontrolvsForecast: false,
      requestcommentaryregionalmanagementvsForecast: false,
      // approvecommentarydialog: false,
      // rejectcommentarydialog: false,
      // commentslevel: "",
      // commentsdialog: false,
      // commentsloading: false,
      trendchartdataset: [],
      trendchart: null,
      charttab: 0,
      tablecolors: {
        heading: { "a": "", "b": "" },
        body: { "a": "", "b": "" }
      },
      // commentsdata: '',
      // commentserror: '',
      multiselectdata: [],
      activitylogdialog: false,
      activitylogloading: false,
      activitylogdata: [],
      bulksubmitfiledatafile: null,
      approverBulkSubmitDataFile: null,
      bulksubmitfiledata: {},
      approverBulkSubmitData: {},
      bulksubmitfiledataList: [],
      approverBulkSubmitFileDataListis: [],
      bulksubmitfiledataerror: false,
      bulksubmitfiledataerrorisApprover: false,
      bulksubmitfiledataerrorisApprover15Characters: false,
      bulksubmitdialog: false,
      approverBulkSubmitPop:false,
      bulksubmitloading: false,
      approverBulkSubmitLoading: false,
      bulksubmitcolumns: [],
      bulkapprovelocalfiledatafile: null,
      bulkapprovelocalfiledata: {},
      bulkapprovelocalfiledataerror: false,
      bulkapprovelocaldialog: false,
      bulkapprovelocalloading: false,
      expandedsubcategory: [],
      customfilter: [],
      searchcustom: "",
      customfiltersdialog: false,
      customfilterstoggle: false,
      userlistdialog: false,
      workflowtext: [],
      activitylogconfigcycle: {
        cycleopen: { icon: "mdi-circle-outline", color: "grey" },
        cycleclose: { icon: "mdi-circle", color: "grey" }
      },
      activitylogconfiggl: {
        a_localbulkadd: { icon: "mdi-plus-circle", color: "info" },
        a_localadd: { icon: "mdi-plus-circle", color: "info" },
        a_localfileadd: { icon: "mdi-plus-circle", color: "info" },
        a_localfileapprove: { icon: "mdi-check-circle", color: "info" },
        a_localapprove: { icon: "mdi-check-circle", color: "success" },
        a_localbulkapprove: { icon: "mdi-check-circle", color: "success" },
        a_localreject: { icon: "mdi-close-circle", color: "error" },
        a_localbulkreject: { icon: "mdi-close-circle", color: "error" },
        a_localrequest: { icon: "mdi-comment-plus", color: "grey" },
        a_regionaladd: { icon: "mdi-plus-circle-outline", color: "info" },
        a_regionalapprove: { icon: "mdi-check-circle-outline", color: "success" },
        a_regionalreject: { icon: "mdi-close-circle-outline", color: "error" },
        a_regionalrequest: { icon: "mdi-comment-plus-outline", color: "grey" },
        f_localbulkadd: { icon: "mdi-plus-circle", color: "info" },
        f_localadd: { icon: "mdi-plus-circle", color: "info" },
        f_localfileadd: { icon: "mdi-plus-circle", color: "info" },
        f_localfileapprove: { icon: "mdi-check-circle", color: "info" },
        f_localapprove: { icon: "mdi-check-circle", color: "success" },
        f_localbulkapprove: { icon: "mdi-check-circle", color: "success" },
        f_localreject: { icon: "mdi-close-circle", color: "error" },
        f_localbulkreject: { icon: "mdi-close-circle", color: "error" },
        f_localrequest: { icon: "mdi-comment-plus", color: "grey" },
        f_regionaladd: { icon: "mdi-plus-circle-outline", color: "info" },
        f_regionalapprove: { icon: "mdi-check-circle-outline", color: "success" },
        f_regionalreject: { icon: "mdi-close-circle-outline", color: "error" },
        f_regionalrequest: { icon: "mdi-comment-plus-outline", color: "grey" },
      },
      alluserassigned: true,
      clientbyclientdialog_netsales: false,
      clientbyclientloading_netsales: false,
      clientbyclientdata_netsales: [],
      filteredClientbyClientDataNetSales: [],
      filteredClientbyClientDataRevenueBreakup: [],
      clientbyclientdialog_revenue: false,
      clientbyclientloading_revenue: false,
      clientbyclientdata_revenue: [],
      filteredClientbyClientDataRevenue: [],
      isMailRemainderRequired: false,
      varianceAnalysisConstants,
      clientbyclient_headers: [
        {
          value: "cl_code",
          text: "Client Code",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "client_name",
          text: "Client Name",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "actual_amount",
          text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actuals'),
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "proforma_amount",
          text: `${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Amount",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "actual_vs_proforma_variance_amount",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Amt",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "commentary1",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Com",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "forecast_amount",
          text: `${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Amount",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "actual_vs_forecast_variance_amount",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Amt",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "commentary2",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Com",
          sortable: false,
          filterable: false,
          lock: true,
        },
      ],
      clientbyclient_headersDemoapp: [
        {
          value: "cl_code",
          text: "Client Code",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "client_name",
          text: "Client Name",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "actual_amount",
          text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actuals'),
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "proforma_amount",
          text: `${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Amount",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "actual_vs_proforma_variance_amount",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Amt",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "commentary1",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma')}` + " Com",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "forecast_amount",
          text: `${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Amount",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "actual_vs_forecast_variance_amount",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Amt",
          sortable: true,
          filterable: true,
          dataType:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER,
          lock: true,
        },
        {
          value: "commentary2",
          text: `${this.$nova.labelsName('cycle_page', 'actual_label', 'Actual')} Vs ${this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')}` + " Com",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "actions",
          text: "Actions",
          sortable: false,
          filterable: false,
          lock: true,
          align: 'center',
          width: '80px',
        },
      ],
      breakdownData: [],
      expandedGroups: [],
      clientTypeHeaders: [
        { text: this.$nova.labelsName('cycle_page','client_name','Client Name'), value: '_id', sortable: false, width: '15%' },
        { text: this.$nova.labelsName('cycle_page','client_code','Client Code'), value: 'clientCode', sortable: false, width: '5%' },
        { text: this.$nova.labelsName('cycle_page','actual_label','Actuals'), value: 'actual_amount', sortable: false, width: '8%' },
        { text: this.$nova.labelsName('cycle_page','proforma_shortform_label','Proforma') + " Amount", value: 'proforma_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') + " Amt", value: 'actual_vs_proforma_variance_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') + " Com", value: 'actual_vs_proforma_commentary', sortable: false, width: '17%' },
        { text: this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Amount", value: 'forecast_amount', sortable: false, width: '8%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Amt", value: 'actual_vs_forecast_variance_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Com", value: 'actual_vs_forecast_commentary', sortable: false, width: '17%' },
      ],
      clientTypeHeadersDemoApp: [
        { text: this.$nova.labelsName('cycle_page','client_name','Client Name'), value: '_id', sortable: false, width: '15%' },
        { text: this.$nova.labelsName('cycle_page','client_code','Client Code'), value: 'clientCode', sortable: false, width: '5%' },
        { text: this.$nova.labelsName('cycle_page','actual_label','Actuals'), value: 'actual_amount', sortable: false, width: '8%' },
        { text: this.$nova.labelsName('cycle_page','proforma_shortform_label','Proforma') + " Amount", value: 'proforma_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') + " Amt", value: 'actual_vs_proforma_variance_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') + " Com", value: 'actual_vs_proforma_commentary', sortable: false, width: '17%' },
        { text: this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Amount", value: 'forecast_amount', sortable: false, width: '8%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Amt", value: 'actual_vs_forecast_variance_amount', sortable: false, width: '10%' },
        { text: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual') + " vs " + this.$nova.labelsName('cycle_page','forecast_shortform_label','Forecast') + " Com", value: 'actual_vs_forecast_commentary', sortable: false, width: '17%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '5%', align: 'center' },
      ],
      netSalesViewMode:"grouped",
      revenueViewMode:"grouped",
      islocalapproverinru: false,
      isregionalapproverinru: false,
      selectedlocalapproval: [],
      selectedregionalapproval: [],
      ruapprovaltype: "",
      ruapprovaldialog: false,
      ruapprovalloading: false,
      commentarycycledatalist: {},
      regionaldata: [],
      page: 1,
      pagecount: 1,
      perpage: varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE,
      previouscyclelistdialog: false,
      previouscyclelistloading: false,
      previouscyclelist: [],
      previouscycledatadialog: false,
      previouscycledataloading: false,
      previouscycledata: [],
      previouscyclemetadata: {},
      previouscycledatatoupload: [],
      uploadrevenuecommentarydialog: false,
      uploadrevenuecommentaryloading: false,
      uploadnetsalescommentarydialog: false,
      uploadnetsalescommentaryloading: false,
      uploadfiledata_revenue: [],
      uploadfiledata_netsales: [],
      uploadclientbyblientfile: null,
      uploadclientbyclienterror: false,
      prevcommentaryselect: [],
      allrudownloaddialog: false,
      allrudownloadloading: false,
      allrudownloadlist: [],
      allRUDownloadPeriod: null,
      allRUDownloadYear: null,
      attachmentfile: null,
      attachmentfileloading: false,
      attachmentfilepercentage: 0,
      commentarySubmitDialogueViewMode: false,
      reportingUnitType:'',
      // is_selected_all_filter:true,
      pagination_page: 0,
      reportingUnitFilter: {},
      isReportingUnitClicked: false,
      hasMoreReportingUnits: false,
      reportingUnitRequestToken: 0, // Token to track latest API request and prevent race conditions
      filterDataPage: 0,
      filterData: {},
      isFilteredData: false,
      commentarydataList: {},
      periodDataList: [],
      networkList: [],
      regionList: [],
      countrylist: [],
      lastUpdatedAt: "",
      appname: '',
      downloadperiodlist: [],
      isGlMandatoryRequestFlag: false,
      replaceExistingCommentFlag: false,
      isbulkapprovalcrosscontrolenabled: false,
      isbulkapprovalmanagementcontrolenabled: false,
      total:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.TOTAL,
      local:varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.LOCAL,
      lastActionsOnGL: { 'localaction': { type: 'none' }, 'regionalaction': { type: 'none' } },
      rulevelapprovenote: "",
      isFiltersDataLoading: false,
      reportingUnitsForMailReminder: [],
      isLocalCommentaryCollapsed:false,
      isLocalCommentaryReasonCollapsed:false,
      bulkUploadCommentaryHeaders: [
        {
          "text": "",
          "value": "ignore",
        },
        {
          "text": this.$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code'),
          "value": "code",
          "filterable": true
        },
        {
          "text": "GL Description",
          "value": "name",
          "filterable": true
        },
        {
          "text": "Commentary 1",
          "value": "commentary1"
        },
        {
          "text": "Commentary 2",
          "value": "commentary2"
        },
        {
          "text": "Message",
          "value": "message",
          "filterable": true
        }
      ],
      bulkUploadCommentaryisApproverHeaders: [
        {
          "text": "",
          "value": "ignore",
        },
        {
          "text": this.$nova.labelsName('cycle_page','commentary_gl_code_label','GL Code'),
          "value": "code",
          "filterable": true
        },
        {
          "text": "GL Description",
          "value": "name",
          "filterable": true
        },
        {
          "text": this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') +  "Commentary 1",
          "value": "commentary1"
        },
        {
          "text": this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + "Commentary 2",
          "value": "commentary2"
        },
        {
          "text": "Message",
          "value": "message",
          "filterable": true
        }
      ],
      isDataRefreshed: false,
      workflows: { "lcp": true, "lmp": true, "rcp": true, "rmp": true, "lcf": true, "lmf": true, "rcf": true, "rmf": true },
      workflowsDisabledMessage: "Workflows Disabled",
      allrucycledownloaddialog: false,
      rucyclepdfdownloaddialog: false,
      rucyclepdfdownloadloading: false,
      allrucycledownloadloading: false,
      allrucycledownloadlist: [],
      rucyclepdfdownloadlist: [],
      allRUcycleDownloadPeriod: null,
      workflowsdialog: false,
      aggregatedLabelText:this.$nova.labelsName('cycle_page', 'commentary_aggregated_key_label', 'Aggregated'),
      allworkflowstext: [this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local') + ' control ' + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local') + ' control ' + this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast'), this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local') + ' management ' + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local') + ' management ' + this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast'),
      this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + ' control ' + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + ' control ' + this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast'), this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + ' management ' + this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') + ' management ' + this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')
      ],
      allworkflowskeys:['Local control proforma','Local control forecast', 'Local management proforma', 'Local management forecast',
        'Regional control proforma', 'Regional control forecast','Regional management proforma', 'Regional management forecast',
        'Local control proforma bs','Local control forecast bs', 'Local management proforma bs', 'Local management forecast bs',
        'Regional control proforma bs', 'Regional control forecast bs','Regional management proforma bs', 'Regional management forecast bs'
      ],
      previewBulkAddCommentary: [],
      previewBulkAddCommentarydialog: false,
      isReportingUnitdataloading: false,
      max_netsales_revenue_dialog_width: 1000,
      cycletypeReadview: 'Proforma',
      cycletypeItem: [{ text: this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'), value: 'Proforma' },
      { text: this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast'), value: 'Forecast' }
      ],
      isCommentaryView: false,
      expandedIds: new Set(),
      isFilterSet: false,
      actual_label: this.$nova.labelsName('cycle_page', 'actual_label', 'Actual'),
      local_controls_label: this.$nova.labelsName('cycle_page', 'local_control_label', 'Local Control'),
      local_management_label: this.$nova.labelsName('cycle_page', 'local_management_label', 'Local Management'),
      regional_controls_label: this.$nova.labelsName('cycle_page', 'regional_control_label', 'Regional Control'),
      regional_management_label: this.$nova.labelsName('cycle_page', 'regional_management_label', 'Regional Management'),
      proforma_shortform_label: this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma'),
      forcast_shortform_label: this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast'),
      commentary_local_key_label: this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local'),
      commentary_regional_key_label: this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional'),
      isAllExpanded: false,
      startIndex: 0,
      endIndex: varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE - 1,
      incrementBy: varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE,
      showSummaryTab: false,
      localCommentaryGenAiBtntab: false,
      isThresholdExceedJVSummarisation: false,
      isThresholdExceedLocalCommentary: false,
      revenueCommentaryStatus: {},
      revenueCommentaryGenAiBtntab: false,
      isThresholdExceedRevenueCommentary: false,
      isRegionalCommentaryAutomationEnabled: false,
      showErrorMessageDialog:false,
      errorMessageDialogContent:'',
      isSodEnabled:true,
      ruRoleOptions:[],
      selectedRuRole:null,
      multiRoleUsers: new Set(), 
      revenueDetailDialog: false,
      selectedRevenueDetail: null,
      DEMOAPPENABLED: process.env.VUE_APP_ENVIRONMENT === 'demoapp',
    }
  },
  props: {
    cycletype: {
      type: String,
      default: '',
    },
  },
  components: {
    cfilter,
    RUList,
    WarningDialog,
    WorkflowsStatus,
    RevenueBreakupDetailedInformation,
    RUViewToolbar,
    RUDataSection,
    BulkPreviewAddCommentaryDialog,
    AllUnitsDataDownloadDialog,
    PdfDownloadDialog,
    CustomFiltersDialog,
    RUCycleDownloadDialog,
    RUApprovalDialog,
    ActivityLogDialog,
    StatusHelpDialog,
    UploadNetSalesCommentaryDialog,
    NetSalesBreakupDialog,
    RevenueBreakupDialog,
    EmailReminderDialog,
    UserListDialog,
    PreviousCycleListDialog,
    PreviousCycleDataDialog,
    RequestCommentaryDialog,
    UploadRevenueCommentaryDialog,
    BulkApproveLocalDialog,
    BulkUploadCommentaryApproverDialog,
    CommentaryDialog,
  },
  // activated() {
  //   // Check if we're coming back from SLBreakup - skip refresh if so
  //   // Note: State restoration is handled in mounted() hook
  //   if (this.$store.state.varianceanalysis.skipReloadOnBack) {
  //     // Don't reset flag here - let mounted() handle it for full state restoration
  //     return;
  //   }
  //   this.refreshData();
  // },
  async mounted() {
    this.appname = "m_" + (this.$route.path || "").split("/")[1] || "";
    
    // Check if we're coming back from SLBreakup - restore state and skip refresh if so
    const isComingBack = this.$store.state.varianceanalysis.skipReloadOnBack;
    
    if (isComingBack) {
      // Restore page state from store
      const savedState = this.$store.state.varianceanalysis.basePageState;
      if (savedState) {
        // Restore all saved state properties
        this.commentarydata = savedState.commentarydata || [];
        this.commentarydatajson = savedState.commentarydatajson || {};
        this.commentarydatajsonById = savedState.commentarydatajsonById || {};
        this.commentarydatajsonByGLCode = savedState.commentarydatajsonByGLCode || {};
        this.commentaryrudata = savedState.commentaryrudata || {};
        this.commentarycycledata = savedState.commentarycycledata || {};
        this.commentarysummarydata = savedState.commentarysummarydata || {};
        this.commentarylocalsummarydata = savedState.commentarylocalsummarydata || {};
        this.commentaryregionalsummarydata = savedState.commentaryregionalsummarydata || {};
        this.hierarchyData = savedState.hierarchyData || {};
        this.selectedrole = savedState.selectedrole || '';
        this.selectedyear = savedState.selectedyear || 2023;
        this.selectedperiod = savedState.selectedperiod || '';
        this.selectednetwork = savedState.selectednetwork || 'all';
        this.selectedregion = savedState.selectedregion || 'all';
        this.selectedcountry = savedState.selectedcountry || 'all';
        this.selectedreportingunit = savedState.selectedreportingunit || '';
        this.toggleview = savedState.toggleview !== undefined ? savedState.toggleview : 0;
        this.toggletableview = savedState.toggletableview !== undefined ? savedState.toggletableview : 0;
        this.ispreparer = savedState.ispreparer || false;
        this.isapprover = savedState.isapprover || false;
        this.isregionalapprover = savedState.isregionalapprover || false;
        this.ismanager = savedState.ismanager || false;
        this.isviewonly = savedState.isviewonly || false;
        this.cyclestage = savedState.cyclestage || 0;
        this.customfilter = savedState.customfilter || [];
        this.customfilterstoggle = savedState.customfilterstoggle || false;
        this.ispendinglocalruapproval = savedState.ispendinglocalruapproval || false;
        this.ispendingregionalruapproval = savedState.ispendingregionalruapproval || false;
        this.gllist = savedState.gllist || {};
        this.tablecolors = savedState.tablecolors || { heading: { "a": "#d0dcff", "b": "#efcef4" }, body: { "a": "", "b": "" } };
        this.period = savedState.period || [];
        this.perioddata = savedState.perioddata || [];
        this.periodlist = savedState.periodlist || {};
        this.network = savedState.network || [];
        this.networkdata = savedState.networkdata || [];
        this.networklist = savedState.networklist || {};
        this.region = savedState.region || [];
        this.regiondata = savedState.regiondata || [];
        this.regionlist = savedState.regionlist || {};
        this.country = savedState.country || [];
        this.countrydata = savedState.countrydata || [];
        this.reportingunit = savedState.reportingunit || [];
        this.reportingunitdata = savedState.reportingunitdata || [];
        this.reportingunitlist = savedState.reportingunitlist || {};
        
        // Restore cache data to prevent API calls
        this.commentarydataList = savedState.commentarydataList || {};
        this.filterData = savedState.filterData || [];
        this.periodDataList = savedState.periodDataList || [];
        this.networkList = savedState.networkList || [];
        this.regionList = savedState.regionList || [];
        this.countrylist = savedState.countrylist || [];

        // Restore role-related state for SOD (critical for maintaining preparer/approver access)
        this.isSodEnabled = savedState.isSodEnabled !== undefined ? savedState.isSodEnabled : true;
        this.ruRoleOptions = savedState.ruRoleOptions || [];
        this.selectedRuRole = savedState.selectedRuRole || null;
        // Restore workflow state
        this.workflows = savedState.workflows || { "lcp": true, "lmp": true, "rcp": true, "rmp": true, "lcf": true, "lmf": true, "rcf": true, "rmf": true };
        this.workflowtext = savedState.workflowtext || [];
        // Restore RU approval state
        this.islocalapproverinru = savedState.islocalapproverinru || false;
        this.isregionalapproverinru = savedState.isregionalapproverinru || false;
        // Restore view state
        this.isReportingUnitClicked = savedState.isReportingUnitClicked || false;
        
        // Ensure userid is set from store (needed for role checks)
        this.userid = this.$store.state.user.id;
        
        // Clear the saved state after restoration
        this.$store.commit('varianceanalysis/clearBasePageState');
      }
      
      // Delay clearing the flag until next tick so child components (like cfilter) 
      // can also check it during their mounted() hooks
      this.$nextTick(() => {
        this.$store.commit('varianceanalysis/setSkipReloadOnBack', false);
      });
    } else {
      this.refreshData();
    }
    
    let colors2 = this.$nova.getColors(3, 0.08);
    // Only set tablecolors if not restored from saved state
    if (!this.tablecolors || !this.tablecolors.body || !this.tablecolors.body.a) {
      this.tablecolors = {
        heading: { "a": "#d0dcff", "b": "#efcef4" },
        body: { "a": colors2[2], "b": colors2[1] }
      }
    }
    // this.labels = localStorage.getItem("lablesList");
    // console.log(this.tablecolors);
    const features = await this.$store.dispatch('varianceanalysis/fetchAiFeatures', this.axios);
    const summaryStatus = features.find(feature => feature.name === 'jv_summarisation');
    this.summaryStatus = summaryStatus;
    this.showSummaryTab = summaryStatus?.platform_admin_enabled && summaryStatus?.super_admin_enabled;
    const localCommentaryStatus  = features.find(feature => feature.name === 'local_commentary_summary');
    this.localCommentaryStatus = localCommentaryStatus;
    this.localCommentaryGenAiBtntab = localCommentaryStatus?.platform_admin_enabled && localCommentaryStatus?.super_admin_enabled;

     const revenueCommentaryStatus  = features.find(feature => feature.name === 'revenue_commentary_summary');
    this.revenueCommentaryStatus = revenueCommentaryStatus;
    this.revenueCommentaryGenAiBtntab = revenueCommentaryStatus?.platform_admin_enabled && revenueCommentaryStatus?.super_admin_enabled;
    const isThresholdExceedRevenueCommentary = revenueCommentaryStatus?.isExceed;
    this.isThresholdExceedRevenueCommentary = isThresholdExceedRevenueCommentary;

    const isThresholdExceedJVSummarisation = summaryStatus?.isExceed;
    this.isThresholdExceedJVSummarisation = isThresholdExceedJVSummarisation;
    const isThresholdExceedLocalCommentary = localCommentaryStatus?.isExceed;
    this.isThresholdExceedLocalCommentary = isThresholdExceedLocalCommentary;
  },
  methods: {
    ...helpers,
    // Guard to prevent duplicate API calls
    async refreshData() {
      if (this.isReportingUnitdataloading) return;
      this.isReportingUnitdataloading = true;
      try {
        if (typeof helpers.refreshData === 'function') {
          await helpers.refreshData.call(this);
        }
      } finally {
        this.isReportingUnitdataloading = false;
      }
    },
    /**
     * Handle reporting unit fetch requests coming from list components.
     * @param {{loadMore?: boolean}|boolean|undefined} payload
     */
    handleReportingUnitRequest(payload) {
      const loadMoreRequested = typeof payload === 'object' && payload !== null
        ? Boolean(payload.loadMore)
        : Boolean(payload);
      if (loadMoreRequested && !this.hasMoreReportingUnits) {
        return;
      }
      this.loadReportingUnit(false, loadMoreRequested);
    },
    handleOpenNetSalesUpload() {
      this.uploadnetsalescommentarydialog = true;
      this.uploadfiledata_netsales = [];
    },
    handleOpenRevenueUpload() {
      this.uploadrevenuecommentarydialog = true;
      this.uploadfiledata_revenue = [];
    },
  },
  computed: {
    // Computed property for back button visibility (avoiding optional chaining in template)
    showBackButton() {
      const storeState = this.$store.state[this.appname];
      if (!storeState) return false;
      
      if (this.cycletype === 'Actual') {
        return storeState.actualFilterStatus && storeState.actualFilterStatus.length !== 1;
      } else if (this.cycletype === 'Forecast') {
        return storeState.forecastFilterStatus && storeState.forecastFilterStatus.length !== 1;
      }
      return false;
    },
    // Filter state from store (persists on navigation)
    selectedfilter: {
      get() {
        return this.$store.state.varianceanalysis.baseSelectedFilter || [0, 1, -1, 5, 6, -2, 7, 4, 3, 9];
      },
      set(value) {
        this.$store.commit('varianceanalysis/setBaseSelectedFilter', value);
      },
    },
    pagedItems() {
      return this.visibleItems.slice(this.startIndex, this.endIndex + 1);
    },
    visibleItems() {
      let [res, expandedIds, isFilterSet] = this.filteredcommentarydataRaw();
      if (isFilterSet) {
        let index = 0;
        return res.map((item) => {
          item.__index = index++;
          return item;
        });
      } else {
        let index = 0;
        return res.filter(item => expandedIds.includes(item.__code) || this.expandedIds.has(item.__code)).map((item) => {
          item.__index = index++;
          return item;
        });
      }
    },
    isSpecialRu(){
    return this.reportingUnitType === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.RU_TYPE.GROUP_M || this.reportingUnitType === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.RU_TYPE.SOXID;
    },

    filteredcommentarydata() {
      let res = this.filteredcommentarydataRaw();
      return res[0];
    },
    previewBulkDialogWidth() {
      return Object.keys(this.bulksubmitfiledata || {}).length > 0 ? '800' : '400';
    },
    isBulkSubmitDisabled() {
      return this.ispreparer && !this.workflows.lcp && !this.workflows.lmp && !this.workflows.lcf && !this.workflows.lmf;
    },
    bulkApproveLocalItems() {
      const data = this.bulkapprovelocalfiledata;
      if (Array.isArray(data)) {
        return data;
      }
      if (data && typeof data === 'object') {
        return Object.keys(data).map(key => ({
          __key: key,
          ...(data[key] || {}),
        }));
      }
      return [];
    },
  },
  watch: {
    visibleItems() {
        // Reset the limit on refresh
        let [, , isFilterSet] = this.filteredcommentarydataRaw();
        this.isFilterSet = isFilterSet;
        this.startIndex = 0;
        this.endIndex = Math.max(this.perpage - 1, 0);
    },
    filteredcommentarydata() {
      this.isAllExpanded = false;
    },
    "customfilterstoggle": function (v) {
      localStorage.setItem("commentary_custom_filter_toggle", v)
    },
    allRUDownloadYear() {
      this.downloadperiodlist = [];
      this.allRUDownloadPeriod = "";
      (this.$refs.childfilter?.hierarchyData?.periodlist || []).filter((item) => item.year === this.allRUDownloadYear)
        .forEach((item) => {
          this.downloadperiodlist.push({ name: item?.month || '', _id: item?._id || '', number: item?.number || 0 })
        });
      this.downloadperiodlist = Array.from(this.downloadperiodlist.sort((a, b) => a.number - b.number));
      this.allRUDownloadPeriod = this.downloadperiodlist[0]?._id || "";
    },
    // CHANGE: if user switches role in dropdown, re-apply flags
    selectedRuRole(newRole) {
      if (newRole) {
        this.applyRoleFlags(newRole);
      }
    },
  },
  beforeDestroy() {
    // Save page state to store when component is destroyed (navigating away)
    // This allows restoring state when navigating back from SLBreakup
    const pageState = {
      commentarydata: this.commentarydata,
      commentarydatajson: this.commentarydatajson,
      commentarydatajsonById: this.commentarydatajsonById,
      commentarydatajsonByGLCode: this.commentarydatajsonByGLCode,
      commentaryrudata: this.commentaryrudata,
      commentarycycledata: this.commentarycycledata,
      commentarysummarydata: this.commentarysummarydata,
      commentarylocalsummarydata: this.commentarylocalsummarydata,
      commentaryregionalsummarydata: this.commentaryregionalsummarydata,
      hierarchyData: this.hierarchyData,
      selectedrole: this.selectedrole,
      selectedyear: this.selectedyear,
      selectedperiod: this.selectedperiod,
      selectednetwork: this.selectednetwork,
      selectedregion: this.selectedregion,
      selectedcountry: this.selectedcountry,
      selectedreportingunit: this.selectedreportingunit,
      toggleview: this.toggleview,
      toggletableview: this.toggletableview,
      ispreparer: this.ispreparer,
      isapprover: this.isapprover,
      isregionalapprover: this.isregionalapprover,
      ismanager: this.ismanager,
      isviewonly: this.isviewonly,
      cyclestage: this.cyclestage,
      customfilter: this.customfilter,
      customfilterstoggle: this.customfilterstoggle,
      ispendinglocalruapproval: this.ispendinglocalruapproval,
      ispendingregionalruapproval: this.ispendingregionalruapproval,
      gllist: this.gllist,
      tablecolors: this.tablecolors,
      period: this.period,
      perioddata: this.perioddata,
      periodlist: this.periodlist,
      network: this.network,
      networkdata: this.networkdata,
      networklist: this.networklist,
      region: this.region,
      regiondata: this.regiondata,
      regionlist: this.regionlist,
      country: this.country,
      countrydata: this.countrydata,
      reportingunit: this.reportingunit,
      reportingunitdata: this.reportingunitdata,
      reportingunitlist: this.reportingunitlist,
      
      // Save cache data
      commentarydataList: this.commentarydataList,
      filterData: this.filterData,
      periodDataList: this.periodDataList,
      networkList: this.networkList,
      regionList: this.regionList,
      countrylist: this.countrylist,

      // Role-related state for SOD
      isSodEnabled: this.isSodEnabled,
      ruRoleOptions: this.ruRoleOptions,
      selectedRuRole: this.selectedRuRole,
      // Workflow state
      workflows: this.workflows,
      workflowtext: this.workflowtext,
      // RU approval state
      islocalapproverinru: this.islocalapproverinru,
      isregionalapproverinru: this.isregionalapproverinru,
      // View state
      isReportingUnitClicked: this.isReportingUnitClicked,
    };
    this.$store.commit('varianceanalysis/setBasePageState', pageState);
  }
}
</script>

<style scoped>
/* Filter toolbar layout - prevents alignment shifts */
.filter-toolbar-container {
  display: flex;
  align-items: center;
  width: 100%;
}

/* Back button container - fixed width for consistent layout */
.back-btn-container {
  /* min-width: 50px;
  width: 50px; */
  flex-shrink: 0;
  display: flex;
  /* align-items: center;
  justify-content: flex-start; */
}

/* Filter wrapper - takes remaining space and centers content */
.filter-wrapper {
  /* flex: 1; */
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 56px; /* Consistent height during loading */
}

/* Sync button container - fixed width for consistent layout */
.sync-btn-container {
  min-width: 120px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.scrollable-card-text {
  max-height: 200px;
  /* Adjust the maximum height as needed */
  overflow-y: auto;
  /* Enable vertical scrolling */
}

.icon {
  margin-right: 8px;
}

.rotate {
  animation: spin 1s linear infinite;
}

.color-box {
  width: 100px;
  height: 100px;
  border: 1px solid #000;
  margin-bottom: 10px;
}

.chip-container {
  display: flex;
  flex-wrap: wrap;
  /* This ensures that the chips wrap when there's no space */
}
.node-container {
  height: 50px;
  margin-right: 5px;
}
.node-container-read{
  height: 90px;
  margin-right: 5px;
}
.node-label {
  top: 0;
  bottom: 0;
  left: 8px;
  /* width: 1px; */
  /* background-color: #000000; */
  display: block; /* Important for visibility */
  height: 100%; /* Make sure it stretches */
  content: "";
}

.padding-level-0 { padding-left: 0px; }
.padding-level-1 { padding-left: 10px; }
.padding-level-2 { padding-left: 20px; }
.padding-level-3 { padding-left: 30px; }
.padding-level-4 { padding-left: 40px; }
.padding-level-5 { padding-left: 50px; }
.padding-level-6 { padding-left: 60px; }
.padding-level-7 { padding-left: 70px; }
.padding-level-8 { padding-left: 80px; }

.v-table-color{
  margin-bottom: 50px;
}
td.description-cell {
    width: 15% !important;
}

.node-container {
  height: 50px;
  margin-right: 5px;
}

.node-container-read {
  height: 90px;
  margin-right: 5px;
}

.node-label {
  top: 0;
  bottom: 0;
  left: 8px;
  /* width: 1px; */
  /* background-color: #000000; */
  display: block;
  /* Important for visibility */
  height: 100%;
  /* Make sure it stretches */
  content: "";
}

.childlevele {
  width: 0.5px;
  background-color: var(--color-hierarchy-border);

}


.v-table-color {
  margin-bottom: 50px;
}

/* td.description-cell {
  width: 15% !important;
} */


.parent-row {
  background-color: #e6f7ff !important;
  font-weight: bold;
  cursor: pointer;
}

.child-row td {
  background-color: #fafafa;
}

.child-row td:first-child {
  padding-left: 24px !important;
}

.toggle-btn {
  min-width: 24px !important;
}


.fixed-modal-content {
  overflow: hidden !important;
  height:fit-content !important;
}

.table-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 70vh;
}
.table-wrapper{
  max-height: 435px; /* adjust as needed */
  overflow-y: auto;
}
.table-wrapper-ungrouped{
    /* max-height: 500px; */
    height: 100%;
    position: relative;
}

.v-dialog--scrollable > .v-card > .v-card__text, .v-dialog--scrollable > form > .v-card > .v-card__text {
    overflow-y: auto !important;
    height: auto !important;

}

.gp-1{
  display: flex ;
  gap:1%;
  justify-content: center;
}

/* Set a minimum width for the first column to accommodate expanded content */
.v-data-table ::v-deep td:first-child {
  max-width: 250px;
}


/* Style for the toggle button to maintain position */
.toggle-btn {
  min-width: 24px;
  width: 24px;
}


.commentary1-textarea ::v-deep .v-input__slot {
  height: 300px;
}
.commentary1-textarea ::v-deep .v-input__slot textarea{
  min-height: 100%;
  max-height: 100%;
  overflow-y: auto;
  margin: 0 2.5px 0 0 !important;
  padding-top: 14px !important;
}
.commentary1-textarea ::v-deep .v-input__append-inner{
  position: absolute;
  right: 5px;
}
.skeleton-textarea{
  height: 200px;
}
/* .font-size-lg {
  font-size: 1.5rem;
}
.font-size-md {
  font-size: 1.200rem;
} */
.border-left-custom {
  border-left: 4px solid var(--custom-border-color) !important;
}
.custom-view-label ::v-deep .v-label {
    font-size: 1rem;
}

.local-commentary-proforma-margin {
  margin-top: 3%;
}

.local-commentary-forecast-margin {
  margin-top: 3.5%;
}
.role-selector{
  cursor: pointer;
  max-width: min-content;
}
/* Remove border from dropdown */
.role-selector >>> .v-input__slot {
  border: none !important;
  box-shadow: none !important;
  cursor: pointer;
  padding: 0 !important;
}

.role-selector >>> fieldset {
  border: none !important;
  cursor: pointer;
}

.highlight-chip {
  color: #c62828 !important;
}
.highlight-chip .v-icon {
  color: #c62828 !important;
}
.highlight-chip--self {
  font-weight: 600 !important;
  box-shadow:0 0 8px rgba(198, 40, 40, 0.35);
}
::v-deep .v-data-table thead {
  background-color: var(--color-table-header-bg) !important;
}

</style>
